<template>
  <mu-card class="aio-input" id="insulin-input">
    <mu-card-actions class="aio-input-header pointer" @click.native="openInput">
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="16px" height="17px" viewBox="24 191 16 17" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M39.8354615,192.110676 C39.6853846,191.963108 39.4416923,191.963108 39.2916154,192.110676 L36.9870769,194.375519 L36.7159231,194.109187 C36.4047692,193.803544 35.9911538,193.635187 35.5511538,193.635187 C35.1109231,193.635187 34.6970769,193.803695 34.386,194.10964 L26.7518462,201.615245 L26.2917692,201.163244 C26.1789231,201.052417 26.029,200.99141 25.8694615,200.99141 C25.7098462,200.99141 25.5598462,201.052568 25.4476923,201.162866 L25.4374615,201.172845 C25.2047692,201.401832 25.2048462,201.774228 25.4376923,202.002912 L26.3272308,202.87675 L25.0699231,204.11293 L25.0356154,204.079213 C24.922,203.967631 24.7711538,203.906245 24.6106154,203.906245 C24.45,203.906245 24.2989231,203.967706 24.1843077,204.080423 L24.1758462,204.08889 C23.9413846,204.319237 23.9413846,204.694128 24.1758462,204.924551 L26.8508462,207.552416 C26.9644615,207.663999 27.1153077,207.725385 27.2758462,207.725385 C27.4365385,207.725385 27.5875385,207.663848 27.701,207.552265 L27.7106154,207.542815 C27.9450769,207.312468 27.9450769,206.937577 27.7106154,206.707154 L27.6746154,206.67185 L28.9319231,205.435745 L29.8194615,206.307618 C29.9323077,206.418445 30.0823077,206.479453 30.2417692,206.479453 C30.4013846,206.479453 30.5513846,206.418369 30.6640769,206.307543 L30.6737692,206.298017 C30.9064615,206.069106 30.9063846,205.69671 30.6735385,205.46795 L30.2056154,205.008238 L37.8397692,197.502633 C38.482,196.871238 38.4818462,195.844087 37.8393846,195.212843 L37.531,194.909922 L39.8353846,192.64523 C39.9856923,192.497662 39.9856923,192.258319 39.8354615,192.110676 L39.8354615,192.110676 Z M37.2957692,196.968231 L33.3056154,200.891242 L32.9046923,200.497376 L36.2495385,197.210144 C36.3997692,197.062501 36.3997692,196.823158 36.2495385,196.67559 C36.238,196.664251 36.2250769,196.655481 36.2125385,196.64588 C36.2027692,196.633482 36.1936923,196.620706 36.1820769,196.609291 L35.4078462,195.848472 C35.2576154,195.700829 35.0141538,195.700829 34.8639231,195.848472 C34.7137692,195.996115 34.7137692,196.235383 34.864,196.383026 L35.4337692,196.942905 L35.055,197.31515 L34.4850769,196.75512 C34.3348462,196.607477 34.0913846,196.607477 33.9411538,196.75512 C33.791,196.902763 33.791,197.142031 33.9412308,197.289674 L34.511,197.849553 L34.1322308,198.221798 L33.5624615,197.661843 C33.4123846,197.514276 33.1686923,197.514276 33.0186154,197.661843 C32.8683846,197.809486 32.8683846,198.04883 33.0186154,198.196397 L33.5883077,198.756352 L33.2095385,199.128597 L32.6397692,198.568642 C32.4896923,198.421075 32.246,198.421075 32.0959231,198.568642 C31.9456923,198.716285 31.9456923,198.955629 32.0959231,199.103196 L32.6656154,199.663076 L32.3606154,199.962746 L30.9398462,198.566979 L34.93,194.643967 C35.0959231,194.480827 35.3164615,194.391016 35.5511538,194.391016 C35.7856923,194.391016 36.0061538,194.480751 36.172,194.643665 L37.2954615,195.747322 C37.638,196.08396 37.6380769,196.631592 37.2957692,196.968231 L37.2957692,196.968231 Z"
            id="Shape" stroke="none" fill="#34CAB9" fill-rule="evenodd"
            transform="translate(31.974063, 199.862692) scale(-1, -1) translate(-31.974063, -199.862692) "></path>
        </svg>
        <mu-flexbox-item class="left16" v-text="title"></mu-flexbox-item>
        <mu-flexbox-item align="right">
          <mu-icon-button
            iconClass="blueIcon"
            v-if="!isOpenInput"
            v-tooltip.top="$t('message.addEntryText')"
            class="card-bar-icon"
            :icon="'add_circle'"
          ></mu-icon-button>
          <mu-icon-button
            iconClass="blueIcon"
            v-if="isOpenInput"
            class="card-bar-icon"
            :icon="'remove_circle_outline'"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <form v-if="isOpenInput">
      <mu-card-text style="padding-bottom: 8px">
        <mu-row gutter>
          <mu-col width="100" tablet="100" desktop="50">
            <mu-text-field
              v-validate
              min="0"
              max="250"
              :data-vv-rules="'required|min_value:0|max_value:250'"
              data-vv-name="units"
              data-vv-value-path="inputValue"
              :errorText="errors.first('units')"
              type="number"
              :label="$t('message.labelUnits')"
              v-model.number="model.units"
              :hintText="`${$t('message.cardInsulin')} ${lowerCaseUnitsLabel}`"
              :fullWidth="true"
            />
          </mu-col>
          <mu-col width="100" tablet="100" desktop="50" v-if="isInsulinTypesReady">
            <mu-select-field
              hintText="Select"
              v-model="model.type"
              v-validate
              :data-vv-rules="'required'"
              data-vv-name="insulin_type"
              data-vv-as="Type"
              data-vv-value-path="inputValue"
              :scroller="scroller"
              :errorText="errors.first('insulin_type')"
              :label="$t('message.labelInsulinType')"
              :fullWidth="true">
              <mu-menu-item
                v-for="(type, index) in insulinTypes"
                :key="'insulin-type' + index"
                :value="type.insulin_type_id"
                :title="mapInsulinTypes(type.type)"/>
            </mu-select-field>
          </mu-col>
        </mu-row>
      </mu-card-text>
    </form>
  </mu-card>
</template>
<script>

  import ScrollerMixin from '../../../../mixins/ScrollerMixin'
  import InsulinMixer from '../../../../mixins/InsulinMixin'
  import InsulinApi from '../../../../api/Tracking/Insulin'

  

  export default {
    name: 'aio-insulin',
    mixins: [ScrollerMixin, InsulinMixer],
    data() {
      return {
        title: this.$t('message.cardInsulin'),
        isOpenInput: false,
        model: {
          units: null,
          type: null
        },
        isInsulinTypesReady: false,
        insulinTypes: []
      }
    },
    watch: {
      'model.units': function () {
        this.trySubmitAndEmitValue()
      },
      'model.type': function () {
        this.trySubmitAndEmitValue();
      }
    },
    mounted() {
      let self = this;
      self.loadData();
    },
    methods: {
      loadData() {
        let self = this;
        if (_.has(self.$store.state.cards.insulin, 'units')) {
          self.insulinTypes = self.$store.state.insulinTypes;
          self.data = self.$store.state.cards.insulin;
          self.loading = false;
          self.isInsulinTypesReady = true;
        }
        else {
          InsulinApi.getInsulinTypes()
            .then(function (response) {
              self.insulinTypes = response.data;
              self.isInsulinTypesReady = true;
              self.$store.commit('setInsulinTypes', response.data);
            });
        }
      },
      openInput() {
        this.isOpenInput = !this.isOpenInput;
      },
      trySubmitAndEmitValue() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.$emit('onValid', self.model);
            }
            else {
              self.$emit('onValid', null);
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Insulin.vue?f26b8fda